export class Sound {
 private context?: AudioContext;
 private clock?: ReturnType<typeof setInterval>;
 private step = 0;
 enabled = false;
 private progress=0;
 private journey=false;
 private ending=false;
 setJourney(progress:number,active:boolean) {this.progress=progress;this.journey=active;this.ending=false;}
 endJourney() {
  this.journey=false;this.ending=true;
  [261.63,311.13,392].forEach((f,i)=>this.tone(f,3,.025,'sine',i*.2));
 }
 async toggle() {
  this.enabled = !this.enabled;
  if (this.enabled) {
   this.context ??= new AudioContext();
   await this.context.resume();
   this.clock = setInterval(() => this.beat(), 60000 / 108 / 2);
   this.beat();
  } else { clearInterval(this.clock); await this.context?.suspend(); }
 }
 private tone(frequency: number, duration: number, volume: number, type: OscillatorType = 'sine', delay = 0) {
  if (!this.enabled || !this.context) return;
  const c = this.context, start = c.currentTime + delay;
  const oscillator = c.createOscillator(), gain = c.createGain();
  oscillator.type = type; oscillator.frequency.setValueAtTime(frequency, start);
  gain.gain.setValueAtTime(0, start); gain.gain.linearRampToValueAtTime(volume, start + .008); gain.gain.exponentialRampToValueAtTime(.0001, start + duration);
  oscillator.connect(gain); gain.connect(c.destination); oscillator.start(start); oscillator.stop(start + duration);
 }
 private beat() {
  if (document.hidden || this.ending) return;
  if ((!this.journey || this.progress>=.18) && this.step % 2 === 0 && this.context) {
   const c = this.context, o = c.createOscillator(), g = c.createGain();
   o.frequency.setValueAtTime(125,c.currentTime); o.frequency.exponentialRampToValueAtTime(42,c.currentTime+.15);
   g.gain.setValueAtTime(.16,c.currentTime); g.gain.exponentialRampToValueAtTime(.0001,c.currentTime+.24);
   o.connect(g);g.connect(c.destination);o.start();o.stop(c.currentTime+.25);
  }
  const notes = [130.81,155.56,174.61,196,233.08,196,174.61,155.56];
  this.tone(notes[this.step % 8], .22, .025, 'triangle');
  if(this.step % 8 === 0) [261.63,311.13,392].forEach(f=>this.tone(f,2,.016));
  if(this.journey&&this.progress>=.4&&this.step%2===1)this.tone(1760,.045,.012,'triangle');
  if(this.journey&&this.progress>=.65&&this.step%4===0)this.tone(notes[this.step%8]/2,.5,.055,'sine');
  if(this.journey&&this.progress>=.82&&this.step%8===0)[523.25,622.25,783.99].forEach(f=>this.tone(f,2.5,.012));
  this.step++;
 }
 pages() {
  if(!this.enabled || !this.context)return;
  const c=this.context;
  for(let i=0;i<6;i++){
   const duration=.13, start=c.currentTime+.35+i*.2;
   const buffer=c.createBuffer(1,Math.ceil(c.sampleRate*duration),c.sampleRate),samples=buffer.getChannelData(0);
   for(let j=0;j<samples.length;j++)samples[j]=(Math.random()*2-1)*Math.sin(j/samples.length*Math.PI);
   const source=c.createBufferSource(),filter=c.createBiquadFilter(),gain=c.createGain();
   source.buffer=buffer;filter.type='bandpass';filter.frequency.value=1800;filter.Q.value=.7;gain.gain.value=.045;
   source.connect(filter);filter.connect(gain);gain.connect(c.destination);source.start(start);
  }
 }
 stamp() {
  this.tone(48,.45,.24,'triangle',.28);
  this.tone(130,.18,.1,'sine',.28);
  [523.25,783.99,1046.5].forEach((f,i)=>this.tone(f,.8,.045,'sine',.45+i*.09));
 }
 correct(index: number) {this.tone([523.25,622.25,698.46,783.99,932.33][index % 5], .7, .10);}
 wrong() {this.tone(87.31,.18,.06,'triangle');}
 complete() {[523.25,622.25,783.99,1046.5].forEach((f,i)=>this.tone(f,1.7,.06,'sine',i*.1));}
}
